import { useParams } from 'react-router-dom';
import { useQrRedirect } from '../hooks/useQrRedirect.js';
import NotFoundPage from './NotFoundPage.jsx';
import ErrorPage from './ErrorPage.jsx';

/**
 * The scanned URL itself: https://qr.ecollat.in/nZJQXo4f4Ooq
 *
 * A spinner is all the visitor should ever see here - anything else means the
 * redirect failed.
 */
export default function RedirectPage() {
  const { qrCodeId } = useParams();
  const { status, error } = useQrRedirect(qrCodeId);

  if (status === 'not-found') return <NotFoundPage />;
  if (status === 'error') return <ErrorPage code={error.code} />;

  return (
    <main className="panel">
      <div className="spinner" role="status" aria-label="Loading" />
      <h1>Taking you there…</h1>
      <p className="muted">Just a moment.</p>
    </main>
  );
}
